import React from 'react';
import trimCharacters from 'trim-characters';
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";

const OverviewCard = ({image, title, description, reverse = false}) => {
    const classes = useStyles();
    return <Grid item container xs={6} md={4} lg={12} className={clsx(classes.grid)}>
        <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            className={clsx(classes.root)}
        >
            <Avatar variant="square" alt="Remy Sharp" src={image} className={classes.avatar}
                    classes={{root: classes.rootAvatar}}/>
            <div className={classes.body}>
                {title && <Typography component={"h2"} className={classes.title}>{title}</Typography>}
                {description &&
                    <Typography className={classes.text}>{trimCharacters(description, 150, false, ' ...')}</Typography>}

            </div>
        </Box>
    </Grid>
}
const useStyles = makeStyles((theme) => ({
    grid: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            justifyContent: "column",
        },
    },
    root: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        gap: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            flexDirection:"column"
        },
    },
    rootAvatar: {
        [theme.breakpoints.down('sm')]: {},
    },
    avatar: {
        width: 120,
        height: 120,
        borderRadius:'10px',

        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: 0,
            paddingTop:'100%',
            "& img":{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: "100%",
                height: "100%",
                objectFit:"cover",
            }
        },
        // [theme.breakpoints.down('sm')]: {
        //     width: 120,
        //     height: 120,
        // },
    },
    body: {
        flex: '1 auto',
    },
    title: {
        color:"#fff",
        fontWeight: theme.typography.fontWeightBold,
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(22),
        paddingBottom: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(16),
            lineHeight: theme.typography.pxToRem(22),
        },
    },
    titlePlaceholder: {
        height: 48,
    },
    text: {
        color:"#fff",
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),
        paddingBottom: theme.spacing(0),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(20),
        },
    },
    reverse: {},
    even: {},

}));
export default OverviewCard;
